import React from "react"
import MetaTags from "react-meta-tags"
import { Container } from "reactstrap"
import AllBranches from "../../components/Admin/Branches"

const BranchesAll = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Branches | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <AllBranches />
        </Container>
      </div>
    </React.Fragment>
  )
}
export default BranchesAll
